import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import classes from "./css/navigation.module.css";
import NavLogo from "./logoNav";

const MainNav = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const isActive = (path) => {
    return location.pathname === path;
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  return (
    <>
      <div className={`${classes.navComponent} ${isScrolled ? classes.scrolled : ''}`}>
        <div className={classes.logo}>
          <NavLogo />
        </div>
        
        {/* Desktop Navigation */}
        <div className={classes.navigation}>
          <ul className={classes.UlNavigation}>
            <li>
              <Link className={classes.UiNavigationLink} to="/">
                Home{isActive("/") && ":)"}
              </Link>
            </li>
            <li>
              <Link className={classes.UiNavigationLink} to="/VivekSharma/tech-pov">
                Insights{isActive("/VivekSharma/tech-pov") && ":) "}
              </Link>
            </li>
            <li>
              <Link className={classes.UiNavigationLink} to="/VivekSharma/about-me">
                about{isActive("/VivekSharma/about-me") && ":) "}
              </Link>
            </li>
            <li>
              <Link className={classes.UiNavigationLink} to="/VivekSharma/lets-connect">
                contact{isActive("/VivekSharma/lets-connect") && ":) "}
              </Link>
            </li>
          </ul>
        </div>

        {/* Hamburger Menu */}
        <div 
          className={`${classes.hamburger} ${isMobileMenuOpen ? classes.active : ''}`}
          onClick={toggleMobileMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <div className={`${classes.mobileMenu} ${isMobileMenuOpen ? classes.active : ''}`}>
        <button className={classes.closeButton} onClick={closeMobileMenu}>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
</button>
        
        <ul className={classes.mobileNavList}>
          <li className={classes.mobileNavItem}>
            <Link 
              className={classes.mobileNavLink} 
              to="/" 
              onClick={closeMobileMenu}
            >
              HOME{isActive("/") && ":)"}
            </Link>
          </li>
          <li className={classes.mobileNavItem}>
            <Link 
              className={classes.mobileNavLink} 
              to="/VivekSharma/about-me" 
              onClick={closeMobileMenu}
            >
              ABOUT{isActive("/VivekSharma/about-me") && ":) "}
            </Link>
          </li>
          <li className={classes.mobileNavItem}>
            <Link 
              className={classes.mobileNavLink} 
              to="/VivekSharma/tech-pov" 
              onClick={closeMobileMenu}
            >
              INSIGHTS{isActive("/VivekSharma/tech-pov") && ":) "}
            </Link>
          </li>
          <li className={classes.mobileNavItem}>
            <Link 
              className={classes.mobileNavLink} 
              to="/VivekSharma/lets-connect" 
              onClick={closeMobileMenu}
            >
              CONTACT{isActive("/VivekSharma/lets-connect") && ":) "}
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
};

export default MainNav;